import { render, staticRenderFns } from "./ramadanContentDetail.vue?vue&type=template&id=4f8a2f44"
import script from "./ramadanContentDetail.vue?vue&type=script&lang=js"
export * from "./ramadanContentDetail.vue?vue&type=script&lang=js"
import style0 from "./ramadanContentDetail.vue?vue&type=style&index=0&id=4f8a2f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports